import React from 'react';
import {
  RailsBlock,
  RailsPageView,
} from '@sls-react/typings/services/rails/tile';
import RenderBlock from '@sls-react/components/legos/RenderBlock';

interface Props {
  allowBlockLayouts?: RailsBlock['layout'][];
  pageView?: RailsPageView | null;
}

const PageView: React.FC<Props> = ({ allowBlockLayouts, pageView }) => {
  if (!pageView) {
    return null;
  }

  const hasHero = !!pageView.blocks.find(
    b =>
      b.layout === 'hero' ||
      b.layout === 'carousel' ||
      b.layout === 'results-grid' ||
      b.layout === 'results',
  );
  const hasTitleBlock = !!pageView.blocks.find(
    b => b.layout === 'text-title' || b.layout === 'lander-header',
  );

  return (
    <>
      {pageView.blocks.map((block, i) => {
        if (allowBlockLayouts && !allowBlockLayouts?.includes(block.layout)) {
          return <React.Fragment key={i} />;
        }

        return (
          <RenderBlock
            key={i}
            block={block}
            pageView={pageView}
            hasHero={hasHero}
            hasTitleBlock={hasTitleBlock}
          />
        );
      })}
    </>
  );
};

export default PageView;
